import { render, staticRenderFns } from "./FeedContentTags.vue?vue&type=template&id=6cd629ec&"
import script from "./FeedContentTags.vue?vue&type=script&lang=ts&"
export * from "./FeedContentTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports